import React from 'react';

const FilterPanel = ({ filters, onFilterChange, onSearch, searchQuery, totalCount, filteredCount }) => {
  return (
    <div style={{
      background: '#0A1220',
      border: '1px solid rgba(59,111,212,0.2)',
      borderLeft: '4px solid #E8941A',
      padding: '28px 32px',
      marginBottom: '32px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Ghost label */}
      <div style={{
        position: 'absolute', top: '-8px', right: '-8px',
        fontFamily: '"Arial Black", sans-serif',
        fontSize: '7rem', fontWeight: 900,
        color: 'rgba(232,148,26,0.04)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>FILTER</div>
      <div style={{
        fontFamily: 'monospace', fontSize: '0.5rem',
        letterSpacing: '0.35em', color: '#E8941A',
        textTransform: 'uppercase', marginBottom: '20px'
      }}>// FILTRER INNLEVERINGER</div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        alignItems: 'end'
      }}>
        {/* Search */}
        <div>
          <label style={{
            display: 'block',
            fontFamily: 'monospace', fontSize: '0.5rem',
            letterSpacing: '0.2em', color: 'rgba(238,240,242,0.4)',
            textTransform: 'uppercase', marginBottom: '8px'
          }}>SØK</label>
          <input
            type="text"
            value={searchQuery}
            onChange={e => onSearch(e?.target?.value)}
            placeholder="Navn, e-post, melding..."
            style={{
              width: '100%',
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(59,111,212,0.25)',
              borderBottom: '2px solid #3B6FD4',
              color: '#EEF0F2',
              padding: '10px 14px',
              fontFamily: 'monospace', fontSize: '0.75rem',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Date range */}
        <div>
          <label style={{
            display: 'block',
            fontFamily: 'monospace', fontSize: '0.5rem',
            letterSpacing: '0.2em', color: 'rgba(238,240,242,0.4)',
            textTransform: 'uppercase', marginBottom: '8px'
          }}>DATOPERIODE</label>
          <select
            value={filters?.dateRange}
            onChange={e => onFilterChange('dateRange', e?.target?.value)}
            style={{
              width: '100%',
              background: '#0A1220',
              border: '1px solid rgba(59,111,212,0.25)',
              borderBottom: '2px solid #3B6FD4',
              color: '#EEF0F2',
              padding: '10px 14px',
              fontFamily: 'monospace', fontSize: '0.75rem',
              outline: 'none',
              cursor: 'pointer',
              appearance: 'none',
              boxSizing: 'border-box'
            }}
          >
            <option value="all">Alle datoer</option>
            <option value="today">I dag</option>
            <option value="week">Siste 7 dager</option>
            <option value="month">Siste 30 dager</option>
            <option value="quarter">Siste 90 dager</option>
          </select>
        </div>

        {/* Opt-in email filter */}
        <div>
          <label style={{
            display: 'block',
            fontFamily: 'monospace', fontSize: '0.5rem',
            letterSpacing: '0.2em', color: 'rgba(238,240,242,0.4)',
            textTransform: 'uppercase', marginBottom: '8px'
          }}>E-POST SAMTYKKE</label>
          <select
            value={filters?.optinEmail}
            onChange={e => onFilterChange('optinEmail', e?.target?.value)}
            style={{
              width: '100%',
              background: '#0A1220',
              border: '1px solid rgba(59,111,212,0.25)',
              borderBottom: '2px solid #3B6FD4',
              color: '#EEF0F2',
              padding: '10px 14px',
              fontFamily: 'monospace', fontSize: '0.75rem',
              outline: 'none',
              cursor: 'pointer',
              appearance: 'none',
              boxSizing: 'border-box'
            }}
          >
            <option value="all">Alle</option>
            <option value="yes">Samtykket</option>
            <option value="no">Ikke samtykket</option>
          </select>
        </div>

        {/* Opt-in SMS filter */}
        <div>
          <label style={{
            display: 'block',
            fontFamily: 'monospace', fontSize: '0.5rem',
            letterSpacing: '0.2em', color: 'rgba(238,240,242,0.4)',
            textTransform: 'uppercase', marginBottom: '8px'
          }}>SMS SAMTYKKE</label>
          <select
            value={filters?.optinSms}
            onChange={e => onFilterChange('optinSms', e?.target?.value)}
            style={{
              width: '100%',
              background: '#0A1220',
              border: '1px solid rgba(59,111,212,0.25)',
              borderBottom: '2px solid #3B6FD4',
              color: '#EEF0F2',
              padding: '10px 14px',
              fontFamily: 'monospace', fontSize: '0.75rem',
              outline: 'none',
              cursor: 'pointer',
              appearance: 'none',
              boxSizing: 'border-box'
            }}
          >
            <option value="all">Alle</option>
            <option value="yes">Samtykket</option>
            <option value="no">Ikke samtykket</option>
          </select>
        </div>

        {/* Read status filter */}
        <div>
          <label style={{
            display: 'block',
            fontFamily: 'monospace', fontSize: '0.5rem',
            letterSpacing: '0.2em', color: 'rgba(238,240,242,0.4)',
            textTransform: 'uppercase', marginBottom: '8px'
          }}>LEST STATUS</label>
          <select
            value={filters?.readStatus}
            onChange={e => onFilterChange('readStatus', e?.target?.value)}
            style={{
              width: '100%',
              background: '#0A1220',
              border: '1px solid rgba(59,111,212,0.25)',
              borderBottom: '2px solid #3B6FD4',
              color: '#EEF0F2',
              padding: '10px 14px',
              fontFamily: 'monospace', fontSize: '0.75rem',
              outline: 'none',
              cursor: 'pointer',
              appearance: 'none',
              boxSizing: 'border-box'
            }}
          >
            <option value="all">Alle</option>
            <option value="unread">Ulest</option>
            <option value="read">Lest</option>
          </select>
        </div>
      </div>
      {/* Results count */}
      <div style={{
        marginTop: '20px',
        paddingTop: '16px',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        display: 'flex', alignItems: 'center', gap: '16px'
      }}>
        <div style={{
          fontFamily: 'monospace', fontSize: '0.6rem',
          letterSpacing: '0.15em', color: 'rgba(238,240,242,0.35)',
          textTransform: 'uppercase'
        }}>
          Viser <span style={{ color: '#E8941A', fontWeight: 700 }}>{filteredCount}</span> av <span style={{ color: '#EEF0F2' }}>{totalCount}</span> innleveringer
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
